import React, { useEffect } from "react"; // Removed useState
import PageContainer from "../containers/PageContainer";
import LoginForm from "../containers/LoginForm";
import { connect } from "react-redux";
import { loginWithToken } from "../actions/accountActions";
import { getCart, saveCart } from "../actions/cartActions";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";

function LoginView({ loginWithToken, getCart, saveCart, user, settings, location }) {
  const { t } = useTranslation();

  const params = new URLSearchParams(location.search);
  const route = params.get("route");
  const accessToken = params.get("accessToken");

  useEffect(() => {
    if (user && user.isAuthenticated) return;

    if (accessToken) {
      loginWithToken(accessToken).then((response) => {
        const loggedUser = response && response.value ? response.value.data : null;
        
        if (loggedUser && loggedUser.isAuthenticated) {
          // Merge cart logic
          getCart(loggedUser.userId, null, true).then((resp) => {
            if (resp?.cart?.saveAfterCartMerge) {
              saveCart(resp.cart);
            }
          });
        }
      });
    }
  }, [loginWithToken, getCart, saveCart, accessToken]); 

  // Redirect logic
  if (user && user.isAuthenticated) {
    if (route) {
      return <Redirect to={`${settings.baseUrl}${route}`} />;
    }
    return <Redirect to={`${settings.baseUrl}`} />;
  }

  return (
      <PageContainer title={t("LoginView")} showShopToolbar={false} wrapperClassName="responsive-bg">
      <LoginForm />
    </PageContainer>
  );
}

function mapStateToProps({ user, settings, cart }) {
  return { user, settings, cart };
}

export default connect(mapStateToProps, { loginWithToken, getCart, saveCart })(LoginView);